import { render } from "./JobCard.vue?vue&type=template&id=2c174972&scoped=true"
import script from "./JobCard.vue?vue&type=script&lang=js"
export * from "./JobCard.vue?vue&type=script&lang=js"

import "./JobCard.vue?vue&type=style&index=0&id=2c174972&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c174972"]])

export default __exports__